import CactusSaddleryLogo from "assets/icons/cactus_saddlery_logo.svg?react";
import BillyCookLogo from "assets/images/billycook-logo.jpg";

/** Corner watermark on saddle photography — must match the product brand, not the page theme. */
export function BrandImageOverlay({ brandName, className }) {
  const bn = (brandName || "").toLowerCase();
  if (bn.includes("billy") || bn === "billycook") {
    return (
      <img
        src={BillyCookLogo}
        alt=""
        className={`${className} object-contain rounded-sm shadow-[0_1px_4px_rgba(0,0,0,0.35)]`}
      />
    );
  }
  if (bn.includes("cactus") || bn === "cactussaddlery") {
    return <CactusSaddleryLogo className={className} />;
  }
  return null;
}

export const ImageGallery = ({
  saddle,
  currentIndex,
  handleImageClick,
  isMobile = false,
}) => {
  if (isMobile) {
    return (
      <div className="w-[90%] flex justify-center flex-col items-center h-auto mx-auto sm:hidden mt-[12px]">
        <div className="relative w-[100%]">
          <img
            src={saddle?.gallery?.[currentIndex]}
            alt="saddle-image"
            className="w-full h-full rounded-[10px]"
          />
          <BrandImageOverlay
            brandName={saddle?.brandName}
            className="w-[90px] h-[40px] absolute bottom-[7px] left-[6px]"
          />
        </div>
        <div className="flex justify-center items-center w-full mt-[12px] gap-x-2">
          {saddle?.gallery?.map((_, index) => (
            <div
              key={index}
              className={`${
                index === currentIndex
                  ? "selected bg-[#5C80B6] border-[#5C80B6] border rounded-[10px]"
                  : "border-[#999999] bg-white border rounded-full"
              } hover:opacity-60 w-[12px] h-[12px] transition-opacity duration-200`}
              onClick={() => handleImageClick(index)}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="hidden lg:flex flex-col justify-center items-center gap-y-[20px] h-full w-[20%]">
        {saddle?.gallery?.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`saddleimg${index + 1}`}
            className={`cursor-pointer ${
              index === currentIndex
                ? "selected border-[#5C80B6] w-[85px] h-[85px] border-2 rounded-[10px]"
                : "border-[#999] border rounded-[10px]"
            } hover:opacity-60 w-[85px] h-[85px] transition-opacity duration-200`}
            onClick={() => handleImageClick(index)}
          />
        ))}
      </div>
      <div className="relative">
        <img
          src={saddle?.gallery?.[currentIndex]}
          alt="saddle-imagess"
          className="w-[540px] md:ml-[10px] xl:ml-[0px] h-[630px]"
        />
        <BrandImageOverlay
          brandName={saddle?.brandName}
          className="w-[90px] h-[46px] absolute bottom-[7px] left-[6px]"
        />
      </div>
    </>
  );
};
